import { React, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const JoinViaInviteCode = ({ children, setCode, code, handleApplyClick }) => {
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [isRulesPopup, setIsRulesPopup] = useState(true);
  const toggleInputVisibility = () => {
    setIsInputVisible(!isInputVisible);
  };
  const { t } = useTranslation();
  const isValid = (val) => {
    let re = /^[a-zA-Z0-9]+$/
    if (re.test(val))  return true
    else return false
  }
  return (
    <>

      <Box className="invite-code-box">
        <div className="invite-code-header">
          <span>{t('join_via_invite_code.join_via_invite_code')}</span>
          <span
            className="invite-code-arrow"
            onClick={toggleInputVisibility}
          >
            {isInputVisible ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="20"
                  y="20"
                  width="20"
                  height="20"
                  rx="10"
                  transform="rotate(180 20 20)"
                  fill="#2F3043"
                />
                <path
                  d="M8 9.33333L10 7.33333M10 7.33333L12 9.33333M10 7.33333V12.6667M16 10C16 6.68627 13.3137 4 10 4C6.68629 4 4 6.68627 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 8.66667L8 10.6667M8 10.6667L10 8.66667M8 10.6667L8 5.33333M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </span>
        </div>

        {isInputVisible && (
          <div className="invite-code-input-container">
            <input
              type="text"
              id="invite-code"
              className="invite-code-input"
              placeholder="invite code"
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              onKeyDown={(e) =>
                !isValid(e.key) &&
                e.preventDefault()
              }
              // required pattern="[a-zA-Z0-9]+"
              value={code?.slice(0,7)}
              minLength={7}
              maxLength={7}
            />
            <button className="invite-code-apply-button" onClick={() => handleApplyClick()}>{t('join_via_invite_code.add')}</button>
          </div>
        )}
      </Box>
    </>

  )
}
export default JoinViaInviteCode;